import store from '@/store';
export const carPositionOption = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  labelWidth: 160,
  border: true,
  index: true,
  selection: false,
  viewBtn: false,
  editBtn:false,
  delBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  rowKey: 'index',
  column: [
    {
      label: '产品类型',
      prop: 'productName',
      display: false,
    },
    {
      label: '租期',
      prop: 'tenancyTerm',
      editDisabled: true,
      search: false,
      editDisplay: true,
      addDisplay: true,
      span: 24,
      type: 'select',
      dicData: [
        // {
        //   label: '12期',
        //   value: 12,
        // },
        {
          label: '24期',
          value: 24,
        },
        {
          label: '36期',
          value: 36,
        },
        {
          label: '48期',
          value: 48,
        },
      ],
      rules: [
        {
          required: true,
          message: '请选择租期',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '产品类型',
      prop: 'productRateTenancyTermIds',
      type: 'select',
      multiple: true,
      searchMultiple: true,
      searchClearable: true,
      hide: true,
      editDisplay: false,
      addDisplay: false,
      dicUrl: '/api/blade-loanProductManagement/loanProductManagement/getList',
      dicMethod: 'get',
      props: {
        label: 'productName',
        value: 'id',
        res: 'data.data',
      },
      search: true,
      searchOrder: 1000,
      span: 24,
      rules: [
        {
          required: true,
          message: '请输入产品名称',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '产品类型',
      prop: 'id',
      type: 'select',
      hide: true,
      editDisabled: true,
      addDisplay: true,
      dicUrl: '/api/blade-loanProductManagement/loanProductManagement/getList',
      dicMethod: 'get',
      props: {
        label: 'productName',
        value: 'id',
        res: 'data.data',
      },
      search: false,
      searchOrder: 1000,
      span: 24,
      rules: [
        {
          required: true,
          message: '请输入产品名称',
          trigger: 'blur',
        },
      ],
      control: (val, form) => {
        let arr = store.getters.productCascaderType || []
        if (val) {
          // 当用户选择了产品时，默认回显租付类型 （如果有的话）
          form.type = arr.find(item => item.productId == val)?.type
        }
      }
    },
    {
      label: '租率',
      prop: 'rateString',
      type: 'select',
      display: false,
      searchClearable: true,
      hide: true,
      props: {
        label: "lable",
        value: "rate",
      },
      search: true,
      span: 24,
    },
    {
      label: '租付类型',
      prop: 'type',
      type: 'select',
      search: true,
      editDisplay: false,
      addDisplay: true,
      span: 24,
      dicData: [
        {
          label: '先付后租',
          value: 0,
        },
        {
          label: '先租后付',
          value: 1,
        },
      ],
      rules: [
        {
          required: true,
          message: '请选择租付类型',
          trigger: 'blur',
        },
      ],
      formatter: (row, value) => {
        if (value == -1) return '无'
        return ['先付后租', '先租后付'][value]
      }
    },
    {
      label: '租付类型',
      prop: 'typeEdit',
      type: 'select',
      search: false,
      hide: true,
      editDisplay: true,
      addDisplay: false,
      span: 24,
      dicData: [
        {
          label: '先付后租',
          value: 0,
        },
        {
          label: '先租后付',
          value: 1,
        },
      ],
      rules: [
        {
          required: true,
          message: '请选择租付类型',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '租率',
      prop: 'rate',
      editDisabled: true,
      search: false,
      editDisplay: true,
      addDisplay: true,
      span: 24,
      append: '%',
      formatter: (val, value, label) => {
        return value ? value + '%' : '';
      },
      rules: [
        {
          required: true,
          message: '请输入租率',
          trigger: 'blur',
        },
        {
          pattern: /^(0(\.0{0,2}[1-9]\d?)?|[1-9]\d?(\.\d{0,2})?)$/,
          message: '利率只能在0-99之间，允许输入两位小数',
          trigger: 'blur',
        },
      ],
    },

    {
      label: '普通代理商返佣比例',
      prop: 'ordinaryAgentsRebateRatio',
      editDisabled: false,
      search: false,
      addDisplay: true,
      editDisplay:false,
      span: 24,
      minWidth:130,
      append: '%',
      formatter: (val, value, label) => {
        return value ? value + '%' : '';
      },
      rules: [
        {
          required: true,
          message: '请输入普通代理商返佣比例',
          trigger: 'blur',
        },
        {
          pattern: /^(0(\.0{0,2}[1-9]\d?)?|[1-9]\d?(\.\d{0,2})?|100)$/,
          message: '普通代理商返佣比例只能在0-100之间，允许输入两位小数',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '省代代理商返佣比例',
      prop: 'provincialAgentsRebateRatio',
      editDisabled: false,
      search: false,
      addDisplay: true,
      editDisplay:false,
      minWidth:130,
      span: 24,
      append: '%',
      formatter: (val, value, label) => {
        return value ? value + '%' : '';
      },
      rules: [
        {
          required: true,
          message: '请输入省代代理商返佣比例',
          trigger: 'blur',
        },
        {
          pattern: /^(0(\.0{0,2}[1-9]\d?)?|[1-9]\d?(\.\d{0,2})?|100)$/,
          message: '省代代理商返佣比例只能在0-100之间，允许输入两位小数',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '武汉代理商返佣比例',
      prop: 'wuhanAgentsRebateRatio',
      editDisabled: false,
      search: false,
      addDisplay: true,
      editDisplay:false,
      span: 24,
      append: '%',
      minWidth:140,
      formatter: (val, value, label) => {
        return value ? value + '%' : '';
      },
      rules: [
        {
          required: true,
          message: '请输入武汉代理商返佣比例',
          trigger: 'blur',
        },
        {
          pattern: /^(0(\.0{0,2}[1-9]\d?)?|[1-9]\d?(\.\d{0,2})?|100)$/,
          message: '武汉代理商返佣比例只能在0-100之间，允许输入两位小数',
          trigger: 'blur',
        },
      ],
    },
  ],
};
